module.exports = __webpack_public_path__ + "files/3f17bcd0ba2f0353e5266ab0b685c299.svg";